import type { PublishCourseDraft200SectionsItemLecturesItemContentType } from './publishCourseDraft200SectionsItemLecturesItemContentType';
import type { PublishCourseDraft200SectionsItemLecturesItemPlatformSupport } from './publishCourseDraft200SectionsItemLecturesItemPlatformSupport';

export type PublishCourseDraft200SectionsItemLecturesItem = {
  /** 강의 콘텐츠 유형 */
  contentType: PublishCourseDraft200SectionsItemLecturesItemContentType;
  /**
   * 강의 시간 (초)
   * @nullable
   */
  duration?: number | null;
  id: number;
  /** 현재 사용자의 강의 수강 완료 여부 */
  isCompleted: boolean;
  /** 섹션 내 강의 순서 */
  order: number;
  /** 강의 콘텐츠 지원 플랫폼 환경 */
  platformSupport: PublishCourseDraft200SectionsItemLecturesItemPlatformSupport;
  title: string;
};
